(() => {
  const sections = document.querySelectorAll('[data-contact-booking]');
  const scriptLoaders = new Map();

  function ensureExternalScript(scriptUrl) {
    if (!scriptUrl) {
      return Promise.resolve();
    }

    if (scriptLoaders.has(scriptUrl)) {
      return scriptLoaders.get(scriptUrl);
    }

    const loader = new Promise((resolve, reject) => {
      const existingScript = Array.from(document.querySelectorAll('script[data-olc-hubspot-script]')).find(
        (script) => script.dataset.olcHubspotScript === scriptUrl
      );

      if (existingScript) {
        if (existingScript.dataset.loaded === 'true') {
          resolve();
          return;
        }

        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.dataset.olcHubspotScript = scriptUrl;
      script.addEventListener(
        'load',
        () => {
          script.dataset.loaded = 'true';
          resolve();
        },
        { once: true }
      );
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    scriptLoaders.set(scriptUrl, loader);
    return loader;
  }

  function mountHubspotEmbed(embed) {
    if (embed.dataset.hubspotInitialized === 'true') return;

    let embedUrl;

    try {
      embedUrl = new URL(embed.dataset.hubspotUrl, window.location.origin);
    } catch (error) {
      embed.classList.add('has-error');
      return;
    }

    const iframe = document.createElement('iframe');
    iframe.src = embedUrl.toString();
    iframe.loading = 'lazy';
    iframe.title = embed.dataset.embedTitle || 'HubSpot embed';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.setAttribute('allow', 'camera *; microphone *; geolocation *; fullscreen *');
    iframe.addEventListener('error', () => {
      embed.classList.add('has-error');
    });
    embed.replaceChildren(iframe);
    embed.dataset.hubspotInitialized = 'true';
  }

  function initHubspotEmbeds(scope) {
    scope.querySelectorAll('[data-hubspot-inline]').forEach((embed) => {
      if (!embed.dataset.hubspotUrl || embed.dataset.hubspotInitialized === 'true') return;

      ensureExternalScript(embed.dataset.hubspotScript)
        .catch(() => undefined)
        .finally(() => {
          mountHubspotEmbed(embed);
        });
    });
  }

  function setActivePanel(section, tabName) {
    section.querySelectorAll('[data-contact-tab]').forEach((tab) => {
      const isActive = tab.dataset.contactTab === tabName;
      tab.setAttribute('aria-selected', String(isActive));
    });

    section.querySelectorAll('[data-contact-panel]').forEach((panel) => {
      const isActive = panel.dataset.contactPanel === tabName;
      panel.classList.toggle('is-active', isActive);

      if (isActive) {
        initHubspotEmbeds(panel);
      }
    });
  }

  function initSection(section) {
    section.querySelectorAll('[data-contact-tab]').forEach((tab) => {
      tab.addEventListener('click', () => setActivePanel(section, tab.dataset.contactTab));
    });

    const activePanel = section.querySelector('[data-contact-panel].is-active');
    if (activePanel) {
      initHubspotEmbeds(activePanel);
    }
  }

  sections.forEach(initSection);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-contact-booking]').forEach(initSection);
  });
})();
